export const STATUS_LABELS = {
  pending: "En attente",
  confirmed: "Confirmée",
  accepted: "Confirmée",
  preparing: "En préparation",
  en_route: "En route",
  ready: "Prête",
  completed: "Terminée",
  refused: "Refusée",
  cancelled: "Annulée",
};

export const STATUS_COLOR = {
  pending: "bg-brand-amber text-black",
  confirmed: "bg-blue-600 text-white",
  accepted: "bg-blue-600 text-white",
  preparing: "bg-indigo-600 text-white",
  en_route: "bg-purple-600 text-white",
  ready: "bg-brand-red text-white",
  completed: "bg-green-700 text-white",
  refused: "bg-red-900 text-white",
  cancelled: "bg-neutral-500 text-white",
};

// Order lifecycle (no "preparing" step). "En route" only for delivery, "Prête" only for pickup.
export const flowFor = (mode) =>
  mode === "delivery"
    ? ["pending", "confirmed", "en_route", "completed"]
    : ["pending", "confirmed", "ready", "completed"];

export const normalizeStatus = (s) => (s === "accepted" ? "confirmed" : s);
